angular.module("cambioSocietaControllante.components", []).component("cambioSocietaControllante", {
    templateUrl: "ng/components/cambioSocietaControllante/cambioSocietaControllante.view.html",
    bindings: {
        richiestePostVendita: "<"
    },
    controllerAs: "cambioSocietaControllanteCtrl",
    controller: function cambioSocietaControllante(
        $location,
        $modalService,
        $arcService,
        $RichiestePostVenditaService,
        $rootScope,
        RichiestePostVendita,
        Contratti
    ) {
        var self = this;

        self.$onInit = function () {
            self.showMapInfo = false;
            self.mapInfo = "";

            if (self.richiestePostVendita.viewIndex == 0) {
                self.richiestePostVendita.viewIndex = 1055;
            }
            self.visibleDownloadChecklist = true;
            self.visibleUploadChecklist = true;
            var contratti = [];
            if (self.richiestePostVendita.metadata.variazioneAnagrafica.contratti.length == 0) {
                contratti.push(Contratti.build({
                    numero: self.richiestePostVendita.metadata.ctrRichiestaList[0].numeroContratto,
                    modulo: self.richiestePostVendita.metadata.ctrRichiestaList[0].numeroModulo
                }));

                self.richiestePostVendita.metadata.variazioneAnagrafica.contratti = contratti;
                self.richiestePostVendita.metadata.variazioneAnagrafica.cambioSocContr = true;
            }

            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PVA1' && !self.richiestePostVendita.readOnly) {
                self.richiestePostVendita.metadata.variazioneAnagrafica.dscCambioSocContr != null &&
                    self.richiestePostVendita.metadata.variazioneAnagrafica.dscCambioSocContr != "" ?
                    self.validityPage(true) : self.validityPage(false);
            }

            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1' || self.richiestePostVendita.readOnly) {
                self.popolateCheckListDownload();
                self.popolateCheckListUpload();
            }

            retrieveStepInfo();
        };

        self.handleChange = function (property, value) {
            switch (property) {
                case "dscCambioSocContr":
                    self.richiestePostVendita.metadata.variazioneAnagrafica.dscCambioSocContr = value;

                    self.richiestePostVendita.metadata.variazioneAnagrafica.dscCambioSocContr != null &&
                        self.richiestePostVendita.metadata.variazioneAnagrafica.dscCambioSocContr != "" ?
                        self.validityPage(true) : self.validityPage(false);
                    break;
                default:
                    break;
            }
        }

        self.popolateCheckListDownload = function () {
            self.restDownloadRunning = true;
            $arcService.downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.listOfDocumentDownload = response.listDocuments;
                    self.visibleDownloadChecklist = response.visible;
                    self.restDownloadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restDownloadRunning = false;
                })
        }

        self.popolateCheckListUpload = function () {
            self.restUploadRunning = true;
            $arcService.uploadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.listOfDocumentUpload = response.listDocuments;
                    self.visibleUploadChecklist = response.visible;
                    self.message = response.message;
                    self.restUploadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restUploadRunning = false;
                })
        }

        self.validityPage = function (validity) {
            self.enableNext = validity;
        }

        self.allegatiChange = function (value) {
            if (self.richiestePostVendita.metadata.variazioneAnagrafica.allegati.length > 0) {
                self.richiestePostVendita.metadata.variazioneAnagrafica.allegati.push(value);
            } else {
                self.richiestePostVendita.metadata.variazioneAnagrafica.allegati[0] = value;
            }
        }

        self.nextValidity = function () {
            var blockIfReadOnly = true;
            if (self.richiestePostVendita.readOnly && self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                blockIfReadOnly = false;
            }
            return self.enableNext &&
                blockIfReadOnly;
        }

        self.backValidity = function () {
            return (self.getWizardMap(self.richiestePostVendita.viewIndex) !== 'PVA1') || self.richiestePostVendita.readOnly ? true : false;
        }

        self.next = function () {
            self.enabledLoader = true;
            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PVA1') {
                $RichiestePostVenditaService
                    .generateDocumentsPv(RichiestePostVendita.build(self.richiestePostVendita))
                    .then(function (response) {
                        if (response.success) {
                            $RichiestePostVenditaService
                                .nextStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                                .then(function (response) {
                                    self.enabledLoader = false;
                                    self.richiestePostVendita = response;

                                    if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                                        retrieveStepInfo();
                                        self.popolateCheckListDownload();
                                        self.popolateCheckListUpload();
                                    }

                                }).catch(function (error) {
                                    console.log(error);
                                    self.enabledLoader = false;
                                });
                        }
                    }).catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                    });
            } else if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                $RichiestePostVenditaService
                    .variazioneAnagSoc(self.richiestePostVendita.metadata.variazioneAnagrafica, self.richiestePostVendita.id, self.richiestePostVendita.viewIndex,
                        self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                    .then(function (response) {
                        if (response.success) {
                            $location.path('/');
                        }
                        self.enabledLoader = false;

                    }).catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                    });
            }
        }

        self.sospendi = function () {
            $RichiestePostVenditaService
                .suspendInstance(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function () {
                    $location.path('/');
                    $modalService.closeModal("suspendInstance");
                })
        }

        self.back = function () {
            if (self.richiestePostVendita.readOnly) {
                $location.path('/');
            } else {
                $RichiestePostVenditaService
                    .backStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                    .then(function (response) {
                        self.enabledLoader = false;
                        self.richiestePostVendita = response;
                        retrieveStepInfo();
                    }).catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                    })

            }

        }

        self.closeModal = function () {
            $modalService.closeModal("suspendInstance");
        }

        self.getWizardMap = function (viewIndex) {
            if (
                $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                })
            ) {
                return $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                }).viewName;
            }
        };

        var retrieveStepInfo = function () {
            self.clearLabelInfo = true;
            self.restStepInfo = true;
            $RichiestePostVenditaService
                .getStepInfo(self.richiestePostVendita.id, self.richiestePostVendita.viewIndex)
                .then(function (response) {
                    if (response.success) {
                        self.showMapInfo = response.showBeMessage;
                        self.mapInfo = response.message;
                        self.restStepInfo = false;
                    }
                    self.clearLabelInfo = false;
                })
                .catch(function (error) {
                    console.log(error);
                    self.restStepInfo = false;
                    self.clearLabelInfo = false;
                });
        }
    }
});